import { h, JSX } from "preact";

import classname from "../../../foundation/utils/classname";

import styles from "./VariantIndicator.module.css";

interface Props {
    class?: string;
    label: string | number;
    icon?: JSX.Element;
}

function VariantIndicator({
    class: cssClass,
    label,
    icon
}: Props) {
    return (
        <div class={classname(styles.variantIndicator, cssClass, {
            [styles.hasIcon]: !!icon
        })}>
            {icon && (
                <div class={styles.icon}>
                    {icon}
                </div>
            )}
            <span class={classname(styles.label, "caption-2 semibold")}>
                {label}
            </span>
        </div>
    );
}

export default VariantIndicator;
